import React from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import { router } from 'expo-router'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'

export default function SingleVisionSection() {
  const { t } = useTranslation(['ui', 'intro'])
  const text = 'intro:sections.singleVision'

  const { animation, onPressIn, onPressOut } = useAnimatedPress()

  const onPress = () => router.navigate('/deals?tag=sv')

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/book.png'),
            imageWrapperStyle: {
              width: '95%',
              height: '95%',
            },
            imageStyle: {
              transform: [
                { translateX: 100 },
                { translateY: Platform.select({ default: 25, web: 50 }) },
                { rotate: '-20deg' },
              ],
            },
            blur: Platform.select({ default: 100, web: 25 }),
            blurStyle: {
              opacity: Platform.select({ default: 0.5, web: 0.75 }),
              transform: [
                { translateX: Platform.select({ default: 0, web: 25 }) },
                { translateY: Platform.select({ default: 50, web: 50 }) },
                { scale: Platform.select({ default: 0.5, web: 0.5 }) },
                { rotate: '-20deg' },
              ],
            },
          }}
        />
      </Pressable>
    </>
  )
}
